const guiColors = {
    'motion-primary': '#6366f1',
    'motion-primary-transparent': 'rgba(99, 102, 241, 0.9)',
    'motion-tertiary': '#4f46e5',

    'looks-secondary': '#764ba2',
    'looks-transparent': 'rgba(99, 102, 241, 0.35)',
    'looks-light-transparent': 'rgba(99, 102, 241, 0.15)',
    'looks-secondary-dark': '#667eea',

    'extensions-primary': '#6366f1',
    'extensions-tertiary': '#4f46e5',
    'extensions-transparent': 'rgba(99, 102, 241, 0.35)',
    'extensions-light': 'rgba(99, 102, 241, 0.12)',

    'drop-highlight': '#818cf8'
};

const blockColors = {
    checkboxActiveBackground: '#6366f1',
    checkboxActiveBorder: '#4f46e5'
};

export {
    guiColors,
    blockColors
};
